import React, {useState} from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { newpass } from '../../services/StudentService';
import { useContext } from 'react';
import { Context } from "../../index";
import { toast } from 'react-toastify';
import { AiOutlineEye } from "react-icons/ai";
import { AiFillEyeInvisible } from "react-icons/ai";
import { SlLock } from "react-icons/sl";

import './style.css'
import useIsMobile from "../../utils/useIsMobile";

function MyPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
    setValue,
    getValues
  } = useForm({
    mode: 'onChange', // Enable onChange mode to validate on every input change
  });

  const navigate = useNavigate();
  const { store } = useContext(Context);

    const isMobile = useIsMobile(); // default breakpoint is 550px

    // Custom validation to check if the second password matches the first one
  const validatePasswordMatch = (value) => {
    const firstPassword = getValues('password'); // Get the value of the first password input
    return value === firstPassword || 'Lösenorden matchar inte.';
  };

const onSubmit = async (data) => {
  try {
    // You can proceed with the API call or additional logic if the form is valid
    if (isValid) {
      console.log('Calling newpass function');
      const studentId = store.user.id
      const response = await newpass(data.password, studentId);
      console.log(response);
      navigate('/settings');
      toast.success('Lösenord har ändrats nu.');
    }
  } catch (error) {
    console.error(error);
  }
};

const [showPassword, setShowPassword] = useState(false);
const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
};


  return (
    <div className="jcc center"
        style={{maxWidth: "580px"}}>

<div className="card2  mt-128 mb-128 ml-8 mr-8">
      
      
      <SlLock style={{ width: '30px', height: '30px',  color: "#8479bc" }} />
      
      
      <h2 className=" mt-32 mb-32">Här byter du ditt lösenord</h2>
      <form className="center" onSubmit={handleSubmit(onSubmit)}>
      <label>Skriv ditt nya lösenord nedan, minst 8 tecken</label>

        <div style={{maxWidth: "270px", margin: "0 auto"}}
            className='password-input-container pl-8 pr-8'>
          <input
            className="mt-8"
            name="password"
            type={showPassword ? 'text' : 'password'}
            {...register('password',  { required: 'Vänligen skriv ditt lösenord',     minLength: {
      value: 8,
      message: 'Lösenordet måste vara minst 8 tecken långt',
    }, })}
          />
          
              <span onClick={togglePasswordVisibility} className='eye'>
                            {showPassword ? (
                                <AiFillEyeInvisible style={{ color: "#54319f", width: '30px', height: '30px', }} />) : (
                                <AiOutlineEye style={{ color: "#54319f", width: '30px', height: '30px', }} />)}
                        </span>
        </div>
        <p className="error">{errors.password && errors.password.message}</p>
       
       
       
        <label className="m-8">Upprepa nya lösenordet</label>
          <div style={{maxWidth: "270px", margin: "0 auto"}}
               className='password-input-container pl-8 pr-8'>          <input
            className="mt-8"
            type={showPassword ? 'text' : 'password'}
            name="passwordRepeat"
            onChange={(e) => setValue('passwordRepeat', e.target.value)}
            {...register('passwordRepeat', {
             
              required: 'Vänligen upprepa ditt lösenord',
              validate: validatePasswordMatch, // Use the custom validation function
            })}
          />
                <span onClick={togglePasswordVisibility} className='eye'>
                            {showPassword ? (
                                <AiFillEyeInvisible style={{ color: "#54319f", width: '30px', height: '30px', }} />) : (
                                <AiOutlineEye style={{ color: "#54319f", width: '30px', height: '30px', }} />)}
                        </span>
        </div>
        <p className="error">{errors.passwordRepeat && errors.passwordRepeat.message}</p>
        <button
            className={`${isMobile ? 'buttonM   mt-16 pl-8 pr-8' : 'button   mt-16 pl-8 pr-8'}`}
        style={{maxWidth: 250}}
        disabled={isSubmitting}
        onClick={handleSubmit}
>
Spara
        </button>
      </form>
    </div>
    </div>
  );
}

export default MyPassword;
